<h1 mat-dialog-title>Confirme</h1>
<div mat-dialog-content>Ao confirmar essa ação, não será possível recuperar os seus dados, você tem certeza?</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancelar</button>
  <div fxFlex></div>
  <button mat-raised-button color="primary" (click)="this.remove()" style="right: 0px">Remover a Conta</button>
</div>
